// extracted by mini-css-extract-plugin
export var table = "styles-module--table--NnPmu";
export var highlight = "styles-module--highlight--sY+Q+";
export var qty = "styles-module--qty--fziYa";
export var selector = "styles-module--selector--4A6bQ";
export var supply = "styles-module--supply--7tlmP";
export var divider = "styles-module--divider--z1X4S";
export var link = "styles-module--link--Z15a7";